import React from 'react';
import styled from 'styled-components';
import ImageWrapper from './layout/ImageWrapper';

const HeroContainer = styled.div`
  padding: 0rem;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;

  @media screen and (max-width: 40rem) {
    div:first-child {
      flex: auto;
    }
  }
`;

const HeroTitle = styled.h1`
  flex: 1;
  margin-bottom: 0.8rem;
  min-width: 100%;
  font-size: x-large;
  width: 100%;
  text-align: center;
`;

const HeroPicContainer = styled.div`
  flex: 1;
  min-width: 100%;
`;

/**
 * Hero section component that displays the main title and image
 * Maps hero content image reference to actual GraphQL image data
 */
const Hero = ({ data, heroContent }) => {
  // Get the image using the reference from hero content
  const heroImage = data[heroContent.image]?.childImageSharp?.fluid;

  return (
    <HeroContainer>
      <HeroTitle>{heroContent.title}</HeroTitle>
      <HeroPicContainer>
        <ImageWrapper
          fluid={heroImage}
          size='normal'
        />
      </HeroPicContainer>
    </HeroContainer>
  );
};

export default Hero;
